export default "__VITE_ASSET__BFncekOv__"